module.exports = __webpack_public_path__ + "static/media/press_1.6613ddc7.jpg";